export const educationData = [
    {
        id: 1,
        institution: 'Lovely Professional University',
        course: 'Bacherlors of Technology in Computer Science & Engineering',
        startYear: '2020',
        endYear: 'present'
    },
    {
        id: 2,
        institution: 'Alphores Junior College',
        course: 'Intermediate',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 3,
        institution: 'Siddhartha High School',
        course: 'Matriculation',
        startYear: '2017',
        endYear: '2018'
    },
]